import { Navigate, Route, Routes } from "react-router";
import AdminApp from "./admin/AdminApp.tsx";
import Player from "./player/Player.tsx";

// Two surfaces share one bundle:
//   /admin/*        — the CMS (Entra-gated at the SWA layer + role-gated server-side)
//   /display/:id    — the per-TV player (anonymous route, display-token gated in code)
export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/admin" replace />} />
      <Route path="/admin/*" element={<AdminApp />} />
      <Route path="/display/:id" element={<Player />} />
      <Route path="*" element={<Navigate to="/admin" replace />} />
    </Routes>
  );
}
